"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

var _framerMotion = require("framer-motion");

var _styles = require("@mui/material/styles");

var _theme = _interopRequireDefault(require("./styles/theme"));

var _CssBaseline = _interopRequireDefault(require("@mui/material/CssBaseline"));

var _Main = _interopRequireDefault(require("./Main"));

var _DocumentProvider = _interopRequireDefault(require("./context/DocumentProvider"));

// Test comment
var App = function App(_ref) {
  var ehrRecord = _ref.ehrRecord,
      requestPatientRecord = _ref.requestPatientRecord,
      isNewRecordAvailable = _ref.isNewRecordAvailable,
      getPatientAttachment = _ref.getPatientAttachment,
      exportCDAAsPDF = _ref.exportCDAAsPDF,
      exportCDAAsPDFLoading = _ref.exportCDAAsPDFLoading,
      setExportCDAAsPDFLoading = _ref.setExportCDAAsPDFLoading;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_styles.ThemeProvider, {
    theme: _theme.default
  }, /*#__PURE__*/_react.default.createElement(_CssBaseline.default, null), ehrRecord ? /*#__PURE__*/_react.default.createElement(_DocumentProvider.default, null, /*#__PURE__*/_react.default.createElement(_framerMotion.AnimatePresence, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Routes, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: ehrRecord ? false : true,
    path: "/",
    element: /*#__PURE__*/_react.default.createElement(_Main.default, {
      ehrRecord: ehrRecord,
      requestPatientRecord: requestPatientRecord,
      isNewRecordAvailable: isNewRecordAvailable,
      getPatientAttachment: getPatientAttachment,
      exportCDAAsPDF: exportCDAAsPDF,
      exportCDAAsPDFLoading: exportCDAAsPDFLoading,
      setExportCDAAsPDFLoading: setExportCDAAsPDFLoading
    })
  })))) : /*#__PURE__*/_react.default.createElement(_reactRouterDom.BrowserRouter, null, /*#__PURE__*/_react.default.createElement(_DocumentProvider.default, null, /*#__PURE__*/_react.default.createElement(_framerMotion.AnimatePresence, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Routes, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: ehrRecord ? false : true,
    path: "/",
    element: /*#__PURE__*/_react.default.createElement(_Main.default, {
      ehrRecord: ehrRecord,
      requestPatientRecord: requestPatientRecord,
      isNewRecordAvailable: isNewRecordAvailable,
      getPatientAttachment: getPatientAttachment,
      exportCDAAsPDF: exportCDAAsPDF,
      exportCDAAsPDFLoading: exportCDAAsPDFLoading,
      setExportCDAAsPDFLoading: setExportCDAAsPDFLoading
    })
  })))))));
};

var _default = App;
exports.default = _default;